// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"a58ae3d5","198":"befe3d21","247":"c2efd9f5","627":"8a76e1ff","653":"1a67baf7","715":"bb431dde","768":"4fd967ec","834":"73378574","923":"6c2b134f","938":"ffb6b54e"}[chunkId] + ".chunk.js";
};